/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': 'Zurück',
  'ai-floating-context-menu.ai-dynamic-surface.close': 'Schließen',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': 'Referenzierung',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Aktionen',
  'ai-smart-button.ai-actions.conversation-starters.loading.text':
    'Möglichkeiten zum Gesprächseinstieg werden geladen …',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Rovo fragen',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Feedback geben',
  'ai-smart-button.ai-actions.help.section.text': 'Hilfe',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Verknüpfen',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Erwähnen',
  'ai-smart-button.ai-actions.input.placeholder': 'Geben Sie ein, womit Sie Hilfe benötigen.',
  'ai-smart-button.ai-actions.input.send-button-label': 'Senden',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NEU',
  'ai-smart-button.ai-actions.no-results-heading': 'Rovo fragen',
  'ai-smart-button.ai-actions.no-results-text': 'Senden Sie Ihren Prompt an Rovo, um einen Chat zu beginnen.',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Symbol: Hinzufügen',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': 'Symbol: Agent',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Symbol: Automatisierung',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatisierungen',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': 'Agenten durchsuchen',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Agenten erstellen',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Automatisierung erstellen',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-actions.static-agent-fallback-1': 'Was sind Rovo-Agenten?',
  'ai-smart-button.ai-actions.static-agent-fallback-2':
    'Wie kann ich Rovo-Agenten in meinem Confluence-Bereich verwenden?',
  'ai-smart-button.ai-actions.static-fallback-1': 'Was ist Rovo-Chat?',
  'ai-smart-button.ai-actions.static-fallback-2': 'Helfen Sie mir bei den ersten Schritten mit Rovo-Chat',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'wie kann ich Ihnen helfen?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Guten Tag {name},',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Schließen',
  'ai-smart-button.feedback-action.ask-question-option': 'Eine Frage stellen',
  'ai-smart-button.feedback-action.can-contact-message':
    'Ja, {product}-Teams dürfen mich kontaktieren, um weitere Informationen zu meinen Erfahrungen zu erhalten, damit Produkte und Services von Atlassian verbessert werden können. Ich akzeptiere die {privacyPolicy}',
  'ai-smart-button.feedback-action.cancel-button-label': 'Abbrechen',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Wählen Sie eine Option aus',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Beschreiben Sie den Bug oder das Problem',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Teilen Sie uns Ihre Meinung mit',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'Was möchten Sie wissen?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Was können wir Ihrer Meinung nach verbessern?',
  'ai-smart-button.feedback-action.leave-comment-option': 'Einen Kommentar hinterlassen',
  'ai-smart-button.feedback-action.privacy-policy-link': '{product}-Datenschutzrichtlinie.',
  'ai-smart-button.feedback-action.report-bug-option': 'Einen Bug melden',
  'ai-smart-button.feedback-action.research-participation-message':
    'Ich würde gerne an der Produktforschung teilnehmen.',
  'ai-smart-button.feedback-action.select-feedback-heading': 'Feedback auswählen',
  'ai-smart-button.feedback-action.submit-button-label': 'Feedback senden',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Einen Verbesserungsvorschlag machen',
  'ai-smart-button.feedback-action.title': 'Feedback geben',
  'ai-smart-button.feedback-item.icon-label': 'Symbol: Feedback',
  'ai-smart-button.reference.close-button-label': 'Schließen',
  'quick-summary.feedback.summary.placeholder':
    'Was hat Atlassian Intelligence gut gemacht? Was könnte verbessert werden?',
  'quick-summary.feedback.title': 'Helfen Sie uns, Atlassian Intelligence zu verbessern',
};
